import React from 'react';
import { useSelector } from 'react-redux';
import { FaArrowRight } from 'react-icons/fa';
import './transport.css';
import one from '../../assest/transport.png';
import { useNavigate } from 'react-router-dom';
import two from '../../assest/transportone.png';
import three from '../../assest/transporttwo.png';
import IncludedAndSolution from '../../components/transport-text/transport';
import ServicesCard from '../../components/home/ServicesCard';
import FaqSection from '../../components/about/FAQ';

const Transport = () => {
    const { language } = useSelector((state) => state.language);
    const navigate = useNavigate();
    const translations = {
        gb: {
            heroContent: {
                title: "Custom Transport Solutions",
                subtitle: "",
                description: "",
                buttonText: "Explore Services"
            },
            aboutSection: {
                title: "About Service",
                content: "Netus platea nec commodo tincidunt felis orci iaculis facilisi. Molestie etiam magnis rutrum penatibus eros non accumsan erat nulla, convallis rhoncus natoque lacinia class viverra platea cubilia, netus luctus tristique quam habitasse taciti nullam fringilla nostra netus class felis magnis sed consequat orci."
            }
        },
        sa: {
            heroContent: {
                title: "حلول النقل المخصصة",
                subtitle: "",
                description: "",
                buttonText: "تواصل معنا"
            },
            aboutSection: {
                title: "حول الخدمة",
                content: "نيتوس بلاتيا نيك كومودو تينسيدونت فيليس أورسي إياكوليس فاسيليسي. مولستي إتيام ماجنيس روتوم بيناتيبوس إيروس نون أكومسان إيرات نولا، كونفاليس رونكوس ناتوكي لاكينيا كلاس فيفيرا بلاتيا كوبيليا، نيتوس لكتوس تريستيكي كوام هابيتاسي تاكيتي نولام فرينجيلا نوسترا نيتوس كلاس فيليس ماجنيس سيد كونسيكوات أورسي."
            }
        },
        fr: {
            heroContent: {
                title: "Solutions de Transport Sur Mesure",
                subtitle: "",
                description: "",
                buttonText: "Contactez-nous"
            },
            aboutSection: {
                title: "À Propos du Service",
                content: "Netus platea nec commodo tincidunt felis orci iaculis facilisi. Molestie etiam magnis rutrum penatibus eros non accumsan erat nulla, convallis rhoncus natoque lacinia class viverra platea cubilia, netus luctus tristique quam habitasse taciti nullam fringilla nostra netus class felis magnis sed consequat orci."
            }
        },
        de: {
            heroContent: {
                title: "Maßgeschneiderte Transportlösungen",
                subtitle: "",
                description: "",
                buttonText: "Kontaktieren Sie uns"
            },
            aboutSection: {
                title: "Über den Service",
                content: "Netus platea nec commodo tincidunt felis orci iaculis facilisi. Molestie etiam magnis rutrum penatibus eros non accumsan erat nulla, convallis rhoncus natoque lacinia class viverra platea cubilia, netus luctus tristique quam habitasse taciti nullam fringilla nostra netus class felis magnis sed consequat orci."
            }
        }
    };

    const t = translations[language] || translations.gb;

    return (
        <>
            <section
                className="equipment-rental-hero py-5"
                style={{
                    background: 'radial-gradient(circle, #ffffff 0%, #f8d4d4 100%)'
                }}
            >
                <div className="container h-100 px-3">
                    <div className="row justify-content-center align-items-center text-center h-100">
                        <div className="col-md-8">
                            <h1 className="mb-3 fw-bold display-4 display-md-3 display-lg-2">
                                {t.heroContent.title}
                                <div className="d-flex justify-content-center mt-2">
                                    <div style={{ width: '40px', height: '3px', backgroundColor: '#c8102e' }}></div>
                                    <div style={{ width: '5px', height: '3px', backgroundColor: '#c8102e', margin: '0 4px' }}></div>
                                    <div style={{ width: '40px', height: '3px', backgroundColor: '#c8102e' }}></div>
                                </div>
                            </h1>
                            <h3 className="mb-4" style={{ color: '#EF4444' }}>
                                {t.heroContent.subtitle}
                            </h3>
                            <p className="mb-4" style={{ color: '#000' }}>
                                {t.heroContent.description}
                            </p>
                            <button
                className="btn btn-primary mt-3 btn-hover mb-5"
                style={{
                  backgroundColor: '#B91C1C',
                  borderRadius: '50px',
                  color: 'white',
                  padding: '10px 30px',
                  border: '0',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                }}
                onClick={() => navigate('/services')}
              >
                {t.heroContent.buttonText}
                <FaArrowRight className="btn-arrow" />
              </button>
                        </div>
                    </div>
                </div>

                <style>{`
          .btn-hover:hover .btn-arrow {
            transform: translateX(3px);
          }
          .btn-hover:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            transition: all 0.3s ease;
          }
        `}</style>
            </section>

            {/* About Section */}
            <section>
                <div className="about-section container">
                    <div className="about-text">
                        <h2>{t.aboutSection.title}</h2>
                        <p>{t.aboutSection.content}</p>
                    </div>
                </div>

                <div className="about-images container">
                    <img
                        src={one}
                        alt={language === 'sa' ? "طريق سريع" : "Highway"}
                        className="main-img"
                    />
                    <img
                        src={two}
                        alt={language === 'sa' ? "شاحنة 1" : "Truck 1"}
                        className="side-img"
                    />
                    <img
                        src={three}
                        alt={language === 'sa' ? "شاحنة 2" : "Truck 2"}
                        className="side-img"
                    />
                </div>
            </section>

            <IncludedAndSolution language={language} />
            <ServicesCard language={language} />
            <FaqSection language={language} />
        </>
    );
};

export default Transport;